var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: ["jury", _vm.separatePage ? "jury--separate" : ""] },
    [
      _c(
        "div",
        { staticClass: "jury__wrapper" },
        [
          !_vm.separatePage
            ? _c("BaseTitle", {
                staticClass: "jury__title",
                attrs: { text: _vm.title }
              })
            : _vm._e(),
          _vm.separatePage
            ? _c("BaseTitle", {
                staticClass: "jury__title",
                attrs: { text: _vm.title, tag: "h1" }
              })
            : _vm._e(),
          _c("BaseText", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.persons.length === 0,
                expression: "persons.length === 0"
              }
            ],
            staticClass: "jury__empty_text",
            attrs: { text: _vm.empty }
          }),
          _vm.persons.length > 0
            ? _c("AppSlider", {
                attrs: { items: _vm.persons, extension: "jpg" }
              })
            : _vm._e(),
          !_vm.separatePage && _vm.persons.length > 0
            ? _c("BaseBtn", {
                attrs: {
                  text: _vm.btnText,
                  customClass: "default",
                  to: "/jury"
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a260290", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a260290","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/JuryBlock.vue
// module id = /ODG
// module chunks = 0 5